// Copyright (c) 2023 Deere & Company

import DuplicatePinPlateView from '../state/duplicate-pin-plate';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateDuplicatePinPlateChanges = (state, action) =>
DuplicatePinPlateView.update(state, {
    $set: action.data
});

export default (state = getWipDefaultState().duplicatePinPlateView, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE]: updateDuplicatePinPlateChanges
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/duplicate-pin-plate.js